import React from 'react';

const DEFAULT_STYLE = {
  fontSize: '0.75rem',
  minWidth: 700,
  borderCollapse: 'collapse',
  backgroundClip: 'padding-box',
};

const THEAD_STYLE = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  '--bs-table-bg': '#198754',
  '--bs-table-border-color': '#157347',
};

/**
 * Tabela com cabeçalho escuro e sticky.
 * @param {React.ReactNode} head  - Conteúdo do <thead> (normalmente um <tr> com <th>s)
 * @param {object}          style - Overrides do estilo inline da <table>
 * @param {React.ReactNode} children - <tbody> e/ou <tfoot>
 */
const DataTable = ({ head, children, style }) => (
  <table
    className="table table-hover table-striped table-sm"
    style={style ? { ...DEFAULT_STYLE, ...style } : DEFAULT_STYLE}
  >
    <thead className="table-dark" style={THEAD_STYLE}>
      {head}
    </thead>
    {children}
  </table>
);

export default DataTable;
